import {
  MILEAGE_SETTING_ADD_NEW,
  MILEAGE_SETTING_ADD_NEW_SUCCESS,
  MILEAGE_SETTING_ADD_NEW_ERROR,
  MILEAGE_SETTING_DELETE,
  MILEAGE_SETTING_DELETE_ERROR,
  MILEAGE_SETTING_DELETE_SUCCESS,
  MILEAGE_SETTING_EDIT,
  MILEAGE_SETTING_EDIT_ERROR,
  MILEAGE_SETTING_EDIT_SUCCESS,
  MILEAGE_SETTING_GET_BY_ID,
  MILEAGE_SETTING_GET_BY_ID_ERROR,
  MILEAGE_SETTING_GET_BY_ID_SUCCESS,
  MILEAGE_SETTING_GET_LIST,
  MILEAGE_SETTING_GET_LIST_ERROR,
  MILEAGE_SETTING_GET_LIST_SUCCESS,
  MILEAGE_SETTING_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  mileageSettings: [],
  mileageSetting: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case MILEAGE_SETTING_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case MILEAGE_SETTING_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        mileageSetting: payload,
      };

    case MILEAGE_SETTING_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case MILEAGE_SETTING_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };

    case MILEAGE_SETTING_GET_LIST_SUCCESS:
      return {
        ...state,
        mileageSettings: payload,
        loading: true,
      };

    case MILEAGE_SETTING_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case MILEAGE_SETTING_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        mileageSetting: payload,
        mileageSettings: state.mileageSettings.concat(payload),
        addSuccess: true,
      };

    case MILEAGE_SETTING_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case MILEAGE_SETTING_EDIT_SUCCESS:
      return {
        ...state,
        mileageSettings: state.mileageSettings.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        mileageSetting: payload,
        error: null,
        loading: true,
        editSuccess: true,
      };

    case MILEAGE_SETTING_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case MILEAGE_SETTING_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        mileageSettings: state.mileageSettings.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case MILEAGE_SETTING_DELETE_ERROR:
    case MILEAGE_SETTING_ADD_NEW_ERROR:
    case MILEAGE_SETTING_EDIT_ERROR:
    case MILEAGE_SETTING_GET_BY_ID_ERROR:
    case MILEAGE_SETTING_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
